// Environment Configuration
const getApiBaseUrl = () => {
    // Check if we're in production (deployed)
    if (process.env.NODE_ENV === 'production') {
        // For Cloudflare Pages, we need to point to a separate backend
        // Update this URL to point to your deployed backend server
        return process.env.REACT_APP_API_BASE_URL || 'https://calendar-backend-jele.onrender.com';
    }

    // For development, use localhost
    return process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
    CALENDAR: `${API_BASE_URL}/api/calendar`,
    USERS: `${API_BASE_URL}/api/users`,
    TASKS: `${API_BASE_URL}/api/tasks`
};

export default API_ENDPOINTS;
